import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { paymentForReport } from "../../api/api";
import { data } from "react-router-dom";
import toast from "react-hot-toast";

const PaymentModal = ({ open, onClose , billDetails }) => {
  const [timer, setTimer] = useState(10);

  useEffect(() => {
    let interval;
    if (open && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [open, timer]);

  const handleClose = () => {
    setTimer(10); 
    // onClose();
  };

  const handlePaymentClick = async () => {
  try {
    if (billDetails?.user_id) {
        localStorage.setItem("payment_user_id", billDetails.user_id);
      }
      
    const payload = {
      BillID: billDetails?.billId,
      amount: parseInt(billDetails?.dueAmount, 10), // Ensure integer
      customerId: billDetails?.user_id,
      email: "",
      name: billDetails?.patientName,
    };

    const response = await paymentForReport(payload);

    if (response?.data?.url && response?.data?.form) {

      
      // Create a form dynamically
      const form = document.createElement("form");
      form.method = "POST";
      form.action = response.data.url;
      form.innerHTML = response.data.form;

      document.body.appendChild(form);
      form.submit(); // 🚀 Redirects to Paytm
    } else {
      console.error("Invalid Paytm response", response);
      toast.error("Payment initiation failed. Try again.");
    }
  } catch (error) {
    console.error("Error in payment", error);
    toast.error("Something went wrong. Please try again later.");
  }
};


  return (
    <Dialog open={open} 
    onClose={handleClose}
    >
      <DialogContent sx={{ textAlign: "center", p: 3, borderRadius: 3 }}>
        <Typography
          variant="h6"
          sx={{ color: "#0FB7A4", fontWeight: "bold", mb: 2 }}
        >
          Attention !!!
        </Typography>
        

        <Typography variant="body1" sx={{ mb: 2 }}>
          You will be now redirected to Payment Gateway for making the online
          payment.
        </Typography>

        <Typography
          variant="body1"
          sx={{ mb: 2, color: "brown", fontWeight: "bold" }}
        >
          Please <u>DO NOT</u> press Back or Refresh button and <u>DO NOT</u>{" "}
          Close the Window
        </Typography>

        <Typography variant="body2">
          until the payment process gets completed and you are redirected back
          to RB Diagnostic website for confirmation on payment done.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        {timer > 0 ? (
          <Box
            sx={{
              background: "#0FB7A4",
              color: "white",
              px: 3,
              py: 1,
              borderRadius: 1,
              fontWeight: "bold",
            }}
          >
            {timer} sec
          </Box>
        ) : (
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              bgcolor: "#0FB7A4",
              borderRadius: 2,
              px: 4,
            }}
            onClick={handlePaymentClick}
          >
            Ok
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PaymentModal;
